import React from 'react';
import { Feedback } from '../Feedback/feedback';
import ProgressBar from './ProgressBar';

interface ProgressBarWithFeedbackProps {
  /** Expects a float between 0 and 1 */
  progress: number;
  feedback?: Feedback.Props;
}

export default function ProgressBarWithFeedback({ progress, feedback }: ProgressBarWithFeedbackProps) {
  const feedbackStyles = Feedback.style(feedback?.type || Feedback.Type.success);

  return (
    <div className='flex flex-col gap-2'>
      <div className='flex items-center gap-2'>
        <ProgressBar progress={progress} progressColor={feedbackStyles.backgroundColor} />
        {feedback && feedbackStyles.icon}
      </div>
      {feedback?.text && <p>{feedback.text}</p>}
    </div>
  );
}
